/* eslint-disable @typescript-eslint/no-explicit-any */
import { Provider, Type } from '@angular/core';
import { ImpexChildQuery, ImpexChildState, ImpexQuery, ImpexState } from '../state';
import { ImpexChildService } from './impex-child/impex-child.service';
import { ImpexService } from './impex/impex.service';

export interface ImpexServiceDef {
  ImpexService: Type<ImpexService<ImpexState<any>>>;
  ImpexQuery: Type<ImpexQuery<ImpexState<any>>>;
  ImpexChildService: Type<ImpexChildService<ImpexChildState<any>>>;
  ImpexChildQuery: Type<ImpexChildQuery<ImpexChildState<any>>>;
}

export function provideImpex(providers: ImpexServiceDef): Provider[] {
  const {
    ImpexService: service,
    ImpexQuery: query,
    ImpexChildService: childService,
    ImpexChildQuery: childQuery,
  } = providers;
  return [
    {
      provide: ImpexService,
      useExisting: service,
    },
    {
      provide: ImpexChildService,
      useExisting: childService,
    },
    {
      provide: ImpexQuery,
      useExisting: query,
    },
    {
      provide: ImpexChildQuery,
      useExisting: childQuery,
    },
  ];
}
